import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "42",
  height: "42",
  viewBox: "0 0 42 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23.2204 22.9996L30.9872 24.3689C37.1415 25.4544 40.3455 32.3263 37.2211 37.7374C37.1565 37.85 37.0274 37.9086 36.8998 37.883C29.7351 36.4117 23.6528 31.1012 21.5013 23.6692L21.3467 23.0656C21.3197 22.9605 21.3212 22.8494 21.3527 22.7458C24.1063 13.377 31.3716 6.54863 40.0978 3.94969C40.2314 3.91065 40.374 3.9677 40.4446 4.08782C44.4489 11.0243 40.3425 19.8316 32.4541 21.2219L23.2204 22.8509C23.1379 22.8659 23.1379 22.9846 23.2204 22.9981V22.9996Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M20.6472 22.7428C20.6772 22.8464 20.6787 22.956 20.6532 23.0611L20.506 23.6437C20.506 23.6527 20.5015 23.6617 20.4985 23.6707C18.347 31.1027 12.2633 36.4117 5.10007 37.8845C4.97395 37.9101 4.84333 37.8515 4.77877 37.7389C1.65434 32.3263 4.85834 25.4559 11.0126 24.3704L18.7794 23.0011C18.862 22.9861 18.862 22.8674 18.7794 22.8539L9.54575 21.2249C1.65734 19.8331 -2.44901 11.0258 1.55525 4.08932C1.62431 3.96921 1.76845 3.91066 1.90207 3.95119C10.6283 6.54863 17.8921 13.377 20.6472 22.7443V22.7428Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M23.3963 6.56515C24.9713 6.57266 26.2475 7.84885 26.255 9.42383C26.255 12.0198 22.006 14.5917 21.1502 15.0841C21.0571 15.1382 20.9445 15.1367 20.8514 15.0841C19.9956 14.5857 15.7451 11.9822 15.7451 9.42383C15.7451 7.84435 17.0243 6.56515 18.6038 6.56515C19.5707 6.55764 20.4731 7.0441 21 7.85486C21.53 7.0486 22.4309 6.56365 23.3963 6.56515Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }